import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { workOrderChargeCostSchema } from './work-order-charge-cost-schema.js';
export const workOrderChargeLineInputSchema = z.object({
    partId: optionalUuidString('Invalid part selection.')
        .nullish()
        .transform((value) => (value == null || value.trim() === '' ? undefined : value))
        .optional(),
    name: z
        .string()
        .trim()
        .min(1, 'What for is required.')
        .max(256, 'What for must be 256 characters or fewer.'),
    cost: workOrderChargeCostSchema,
    uomId: optionalUuidString('Invalid unit of measure selection.')
        .nullish()
        .transform((value) => (value == null || value.trim() === '' ? undefined : value))
        .optional(),
});
//# sourceMappingURL=charge-line-input.js.map